const Root = (): null => {
  return null;
};

export { Root };
